import axios from "axios";
import { BASE_URL } from "./env";

/**
 *
 * @param {string} token
 * @return AxiosInstance
 */

export const developAxios = (token) =>
	axios.create({
		baseURL: BASE_URL,
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	});

const JUDGE_COMPILER = "https://lambda.cantileverlabs.com";

const compilerAxios = axios.create({
	baseURL: JUDGE_COMPILER,
	headers: {
		"Content-Type": "application/json",
	},
});

compilerAxios.defaults.retry = 5;
compilerAxios.defaults.retryDelay = 1000;

compilerAxios.interceptors.response.use(undefined, (err) => {
	const { config, message } = err;
	// If config does not exist or the retry option is not set, reject
	if (!config || !config.retry) return Promise.reject(err);

	// Set the variable for keeping track of the retry count
	config.__retryCount = config.__retryCount || 0;

	// Check if we've maxed out the total number of retries
	if (config.__retryCount >= config.retry) {
		// Reject with the error
		return Promise.reject(err);
	}

	// Increase the retry count
	config.__retryCount += 1;

	if (message.includes("Network Error")) {
		return new Promise((resolve) => {
			setTimeout(
				() => resolve(compilerAxios(config)),
				config.retryDelay || 1000
			);
		});
	}

	return Promise.reject(err);
});

export { compilerAxios };
